export const RecieptData=[
    {"id":1,
      "payment_organisation_id": "ORG12345",
      "payment_type": "Subscription",
      "payment_mode": "Credit Card",
      "payment_identification_number": "PAY100001",
      "payment_description": "Monthly subscription for premium service",
      "payment_date": "2025-08-01",
      "payment_status": "Completed",
      "payment_amount": 29.99,
      "payment_invoice_no": "INV2025080001",
      "payment_datetime": "2025-08-01T10:15:30Z",
      "payment_from_id": "USER98765",
      "payment_from_role": "Customer",
      "payment_gateway_transaction_number": "TXN456789123",
      "payment_currency": "USD",
      "payment_card_number": "**** **** **** 1234",
      "payment_transaction_charge": 0.75
    },
    {"id":2,
      "payment_organisation_id": "ORG67890",
      "payment_type": "One-Time",
      "payment_mode": "Bank Transfer",
      "payment_identification_number": "PAY100002",
      "payment_description": "Purchase of software license",
      "payment_date": "2025-08-02",
      "payment_status": "Pending",
      "payment_amount": 199.00,
      "payment_invoice_no": "INV2025080002",
      "payment_datetime": "2025-08-02T14:22:45Z",
      "payment_from_id": "USER54321",
      "payment_from_role": "Client",
      "payment_gateway_transaction_number": "TXN789123456",
      "payment_currency": "EUR",
      "payment_card_number": null,
      "payment_transaction_charge": 2.50
    },
    {"id":3,
      "payment_organisation_id": "ORG12345",
      "payment_type": "Recurring",
      "payment_mode": "PayPal",
      "payment_identification_number": "PAY100003",
      "payment_description": "Annual membership renewal",
      "payment_date": "2025-08-03",
      "payment_status": "Completed",
      "payment_amount": 99.00,
      "payment_invoice_no": "INV2025080003",
      "payment_datetime": "2025-08-03T09:10:15Z",
      "payment_from_id": "USER11223",
      "payment_from_role": "Member",
      "payment_gateway_transaction_number": "TXN123456789",
      "payment_currency": "USD",
      "payment_card_number": null,
      "payment_transaction_charge": 1.50
    },
    {"id":4,
      "payment_organisation_id": "ORG09876",
      "payment_type": "One-Time",
      "payment_mode": "Debit Card",
      "payment_identification_number": "PAY100004",
      "payment_description": "Payment for consulting services",
      "payment_date": "2025-08-04",
      "payment_status": "Failed",
      "payment_amount": 500.00,
      "payment_invoice_no": "INV2025080004",
      "payment_datetime": "2025-08-04T16:35:20Z",
      "payment_from_id": "USER44556",
      "payment_from_role": "Customer",
      "payment_gateway_transaction_number": "TXN987654321",
      "payment_currency": "GBP",
      "payment_card_number": "**** **** **** 5678",
      "payment_transaction_charge": 3.00
    },
    {"id":5,
      "payment_organisation_id": "ORG54321",
      "payment_type": "Subscription",
      "payment_mode": "UPI",
      "payment_identification_number": "PAY100005",
      "payment_description": "Monthly cloud storage plan",
      "payment_date": "2025-08-05",
      "payment_status": "Completed",
      "payment_amount": 15.00,
      "payment_invoice_no": "INV2025080005",
      "payment_datetime": "2025-08-05T12:45:00Z",
      "payment_from_id": "USER78901",
      "payment_from_role": "Subscriber",
      "payment_gateway_transaction_number": "TXN654321987",
      "payment_currency": "INR",
      "payment_card_number": null,
      "payment_transaction_charge": 0.30
    }
  ]
